import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import QuillionzProUpgradeModal from "../../../components/modals/QuillionzProUpgradeModal";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";


function WhQuestionsRenderer({
  questions,
  handleShortWhQuestionChange,
  handleShortWhAnswerChange,
  handleShortWhQuestionsEdit,
  handleShortWhAnswersEdit,
  handleShortWhQuestionDelete,
  handleSource,
  user
}) {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  let totalQuestion = 1;
  const Version = localStorage.getItem('userVersion');

  // For PRO users or GPT users, normalize all questions (to handle old/new format)
const isProOrGpt = Version === 'PRO' || user.isGPT;
const normalizedQuestions = isProOrGpt
  ? questions.map((q, index) => ({
      ...normalizeQuestion(q, "qa"),
      editing: q.editing,
      editingAnswer: q.editingAnswer,
    }))
  : questions;

  // return (
  //   <>
  //     {questions.map((whQuestion, index) => (
  //       <div
  //         key={index}
  //         className="mb-4 border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
  //       >
  //         <div className="flex place-content-between">
  //           <div className="flex ">
  //             <span>{totalQuestion++}. </span>{" "}
  //             {whQuestion.editing ? (
  //               <div
  //                 contentEditable="true"
  //                 id={`question-${index}`}
  //                 className="wh-question-editable "
  //                 onBlur={(e) => {
  //                   handleShortWhQuestionChange(index, e.target.textContent);
  //                   handleShortWhQuestionsEdit(index);
  //                 }}
  //                 dangerouslySetInnerHTML={{ __html: whQuestion.question }}
  //               />
  //             ) : (
  //               <span
  //                 onClick={() => handleShortWhQuestionsEdit(index)}
  //                 className="cursor-pointer"
  //                 dangerouslySetInnerHTML={{ __html: whQuestion.question }}
  //               />
  //             )}
  //           </div>
  //           <div className="flex  edit-delete-icons">
  //          {!user.isGPT  &&
  //          <Tooltip
  //               title="Source"
  //               arrow
  //               placement="top"
  //               TransitionComponent={Zoom}
  //               TransitionProps={{ timeout: 300 }}
  //             >
  //               <button
  //                 onClick={() => handleSource(whQuestion.originalSentence)}
  //                 className="text-[#f4843e] mr-2"
  //               >
  //                 <i className="fa-solid fa-book"></i>{" "}
  //               </button>
  //             </Tooltip>}
  //             <Tooltip
  //               title="Edit"
  //               arrow
  //               placement="top"
  //               TransitionComponent={Zoom}
  //               TransitionProps={{ timeout: 300 }}
  //             >
  //               <button
  //                 onClick={() => handleShortWhQuestionsEdit(index)}
  //                 className="text-indigo-500 mr-2"
  //               >
  //                 <i className="fa-solid fa-pen-to-square"></i>{" "}
  //               </button>
  //             </Tooltip>

  //             <Tooltip
  //               title="Delete"
  //               arrow
  //               placement="top"
  //               TransitionComponent={Zoom}
  //               TransitionProps={{ timeout: 300 }}
  //             >
  //               <button
  //                 onClick={() => handleShortWhQuestionDelete(index)}
  //                 className="text-red-500"
  //               >
  //                 <i className="fa-solid fa-trash"></i>{" "}
  //               </button>
  //             </Tooltip>
  //           </div>
  //         </div>
  //         <p>
  //         <div className="flex">
  //         <p className="font-semibold min-w-max">Answer:</p>
  //           {whQuestion.editingAnswer ? (
  //             <div
  //               contentEditable="true"
  //               className="answer-editable flex-grow border-b-2 border-gray-300 outline-none ml-2"
  //               onBlur={(e) => {
  //                 handleShortWhAnswerChange(index, e.target.textContent);
  //                 handleShortWhAnswersEdit(index);
  //               }}
  //               dangerouslySetInnerHTML={{ __html: whQuestion.answer }}
  //             />
  //           ) : (
  //             <span
  //               onClick={() => handleShortWhAnswersEdit(index)}
  //               className="cursor-pointer flex-grow ml-2"
  //               dangerouslySetInnerHTML={{ __html: whQuestion.answer }}
  //             />
  //           )}
  //           </div>
  //         </p>
  //       </div>
  //     ))}
  //    {user.isFree && 
  //    <div className="">
  //         <div className="absolute w-full h-full bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-[#ffffff9c]">
  //           <button
  //             onClick={() => setShowSubscriptionModal(!0)}
  //             className="rounded hover:opacity-80 bg-[#f4833d] text-white px-4 py-2 mt-1 transition duration-300 ease-in-out"
  //           >
  //             Subscribe
  //           </button>
  //           <QuillionzProUpgradeModal
  //             isOpen={showSubscriptionModal}
  //             onClose={() => setShowSubscriptionModal(!1)}
  //         />
  //        </div>
  //     </div>}
  //   </>
  // );
  return (
    <>
      {(isProOrGpt ? normalizedQuestions : questions).map((whQuestion, index) => (
        <div
          key={index}
          className="mb-4 border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
        >
          <div className="flex place-content-between">
            <div className="flex">
              <span>{totalQuestion++}. </span>{" "}
              {whQuestion.editing ? (
                <div
                  contentEditable="true"
                  id={`question-${index}`}
                  className="wh-question-editable"
                  onBlur={(e) => {
                    handleShortWhQuestionChange(index, e.target.textContent);
                    handleShortWhQuestionsEdit(index);
                  }}
                  dangerouslySetInnerHTML={{ __html: whQuestion.question }}
                />
              ) : (
                <span
                  onClick={() => handleShortWhQuestionsEdit(index)}
                  className="cursor-pointer"
                  dangerouslySetInnerHTML={{ __html: whQuestion.question }}
                />
              )}
            </div>
            <div className="flex edit-delete-icons">
              {/* {!user.isGPT && whQuestion.originalSentence && (
                <Tooltip title="Source" arrow placement="top" TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                  <button
                    onClick={() => handleSource(whQuestion.originalSentence)}
                    className="text-[#f4843e] mr-2"
                  >
                    <i className="fa-solid fa-book"></i>
                  </button>
                </Tooltip>
              )} */}
              <Tooltip title="Edit" arrow placement="top" TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                <button onClick={() => handleShortWhQuestionsEdit(index)} className="text-indigo-500 mr-2">
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>
              </Tooltip>
              <Tooltip title="Delete" arrow placement="top" TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                <button onClick={() => handleShortWhQuestionDelete(index)} className="text-red-500">
                  <i className="fa-solid fa-trash"></i>
                </button>
              </Tooltip>
            </div>
          </div>
  
          <div className="flex mt-2">
            <p className="font-semibold min-w-max">Answer:</p>
            {whQuestion.editingAnswer ? (
              <div
                contentEditable="true"
                className="answer-editable flex-grow border-b-2 border-gray-300 outline-none ml-2"
                onBlur={(e) => {
                  handleShortWhAnswerChange(index, e.target.textContent);
                  handleShortWhAnswersEdit(index);
                }}
                dangerouslySetInnerHTML={{ __html: whQuestion.answer }}
              />
            ) : (
              <span
                onClick={() => handleShortWhAnswersEdit(index)}
                className="cursor-pointer flex-grow ml-2"
                dangerouslySetInnerHTML={{ __html: whQuestion.answer }}
              />
            )}
          </div>
        </div>
      ))}
  
      {user.isFree && (
        <div className="absolute w-full h-full bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-[#ffffff9c]">
          <button
            onClick={() => setShowSubscriptionModal(true)}
            className="rounded hover:opacity-80 bg-[#f4833d] text-white px-4 py-2 mt-1 transition duration-300 ease-in-out"
          >
            Subscribe
          </button>
          <QuillionzProUpgradeModal
            isOpen={showSubscriptionModal}
            onClose={() => setShowSubscriptionModal(false)}
          />
        </div>
      )}
    </>
  );  
}

export default WhQuestionsRenderer;
